const FONTS = {
  semiBold: '"OpensansSemiBold", Arial, helvetica, sans-serif',
  regular: '"OpensansRegular", Arial, helvetica, sans-serif',
  light: '"OpensansLight", Arial, helvetica, sans-serif',
  italic: '"OpensansItalic", Arial, helvetica, sans-serif',
  altRegular: '"LeagueGothicRegular", georgia,times,serif',
  proximaNovaRegular: '"ProximaNovaRegular", Arial, helvetica, sans-serif',
  proximaBold: '"ProximaNovaBold", Arial, helvetica, sans-serif',
  robotoCondensed: '"Roboto Condensed", "OpensansRegular", Arial, helvetica, sans-serif'
}

export default FONTS
